export default __webpack_public_path__ + "static/media/sports.08890169.jpg";